import styled from 'styled-components'

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

interface LoaderWrapperProps {
  extend: boolean
}

export const LoaderWrapper = styled.div<LoaderWrapperProps>`
  ${(props) => props.extend && `
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`
